export const userReferralsDefaultState = {
   pagination: {
      page: 1,
      limit: 50,
      total: null,
   },
   counts: {
      signups: null,
      membershipsPurchased: null,
      profilesCompleted: null,
   },
   userReferrals: null,
   membershipRewards: null,
};
